export const WINE_RANGE = [
  {
    label: "Gledswood Label",
    categories: [
      { type: "Sparkling", wines: ["Cuvée Blanc", "Pink Moscato"] },
      { type: "Whites", wines: ["Moscato", "Chardonnay", "Sauvignon Blanc", "Riesling"] },
      { type: "Pink", wines: ["Rosé"] },
      { type: "Reds", wines: ["Shiraz", "Cabernet Merlot"] },
    ],
  },
  {
    label: "Small Estates Label",
    categories: [
      { type: "Sparkling", wines: ["Prosecco", "Sparkling Shiraz"] },
      { type: "Whites", wines: ["Chardonnay"] },
    ],
  },
  {
    label: "c.1810 Chisholm Label",
    categories: [
      { type: "Whites", wines: ["Vermentino"] },
      { type: "Reds", wines: ["Sangiovese", "Pinot Noir"] },
    ],
  },
];

export const MENU_ITEMS = [
  {
    name: "Charcuterie selection",
    note: "Check blackboard",
    options: [["1 choice", "$32"], ["2 choices", "$55"], ["3 choices", "$80"]],
  },
  {
    name: "Cheese selection",
    note: "Check blackboard",
    options: [["1 choice", "$30"], ["2 choices", "$55"], ["3 choices", "$75"]],
  },
  { name: "Selection of bread, red gum smoked salted butter", price: "$12" },
  { name: "Warm marinated olives", price: "$9" },
  { name: "Salmon donuts, miso mayonnaise, furikake", price: "$25" },
  { name: "Crab cakes, chilli, corn", price: "$25" },
  { name: "Chorizo and Manchego croquettes, romesco, pickles", price: "$24" },
  { name: "Potato hash brown, maple bacon, Taleggio", price: "$24" },
  { name: "Chilli black bean cauliflower, shallot", price: "$23" },
  { name: "Corn and saffron arancini, herb mayonnaise", price: "$22" },
];

// Legacy export kept for confirmation view
export const BAR_MENU = { wines: [], grazing: MENU_ITEMS };
